"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const use_department_1 = __importDefault(require("@/SearchApp/composables/use-department"));
const use_most_suggested_request_1 = __importDefault(require("@/SearchApp/composables/use-most-suggested-request"));
const use_search_1 = __importDefault(require("@/SearchApp/composables/use-search"));
const dataLayer_1 = require("@/SearchApp/services/dataLayer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ToggleItem',
    props: {
        departmentType: {}
    },
    setup(__props) {
        const props = __props;
        const { department } = (0, use_department_1.default)();
        const { loadSuggestions } = (0, use_most_suggested_request_1.default)();
        const { setUpRequest, focusSearch } = (0, use_search_1.default)();
        const setDepartmentSearch = () => {
            department.value = props.departmentType;
            loadSuggestions();
            setUpRequest();
            focusSearch();
            (0, dataLayer_1.tr_searchDepartmentToggle)({ action: "department-switch", label: props.departmentType, searchterm: undefined });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                class: (0, vue_2.normalizeClass)(["flex items-center border-b-2 hover:border-b-current hover:text-black-primary", (0, vue_2.unref)(department) === _ctx.departmentType ? 'text-black-primary' : 'border-b-transparent'])
            }, [
                (0, vue_2.createElementVNode)("button", {
                    type: "button",
                    class: "h-full px-4 focus:-outline-offset-2",
                    onClick: setDepartmentSearch
                }, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                ])
            ], 2));
        };
    }
});
